export const languageSelector = (state) => state.app.currentCountry.language;
export const countryCodeSelector = (state) => state.app.currentCountry && state.app.currentCountry.code.toLowerCase();
export const apiTokenSelector = ({ user }) => user.apiToken;
